import { colors } from '@material-ui/core';

const data = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default data;
